async function initTestimonialProductSlider(section) {

  if (!section) return;


  /* ================================================
     LOAD SLICK FIRST
  ================================================= */

  if (typeof window.loadSlick !== 'function') {
    console.error('Slick loader is not available.');
    return;
  }


  try {

    await window.loadSlick();

  } catch (error) {

    console.error('Failed to load Slick:', error);
    return;

  }


  /* ================================================
     CHECK JQUERY + SLICK
  ================================================= */

  if (
    typeof window.jQuery === 'undefined' ||
    typeof window.jQuery.fn.slick === 'undefined'
  ) {

    console.error(
      'jQuery or Slick is not available after loading.'
    );

    return;

  }


  /* ================================================
     NOW IT IS SAFE TO USE JQUERY
  ================================================= */

  const $section = jQuery(section);


  const $textSlider = $section.find(
    '.testimonial-product-slider__text-slider'
  );


  if (!$textSlider.length) {
    return;
  }


  /* ================================================
     PREVENT DOUBLE INITIALIZATION
  ================================================= */

  if ($textSlider.hasClass('slick-initialized')) {
    return;
  }


  /* ================================================
     UPDATE ARROW COLORS
  ================================================= */

  function updateArrowColors(currentSlide) {

    const slickInstance =
      $textSlider.slick('getSlick');

    const total =
      slickInstance.slideCount;

    if (!total) {
      return;
    }


    const $prevArrow =
      $section.find(
        '.testimonial-product-slider__prev'
      );


    const $nextArrow =
      $section.find(
        '.testimonial-product-slider__next'
      );


    $section.removeClass(
      'is-first-slide is-middle-slide is-last-slide'
    );


    /* Reset arrows */

    $prevArrow
      .prop('disabled', false)
      .css({
        color: '#5C5757',
        opacity: '1',
        cursor: 'pointer'
      });


    $nextArrow
      .prop('disabled', false)
      .css({
        color: '#5C5757',
        opacity: '1',
        cursor: 'pointer'
      });


    /* ==========================================
       FIRST SLIDE
    ========================================== */

    if (currentSlide === 0) {

      $section.addClass(
        'is-first-slide'
      );


      $prevArrow
        .prop('disabled', true)
        .css({
          color: '#6E6969',
          opacity: '1',
          cursor: 'not-allowed'
        });


      $nextArrow
        .prop('disabled', false)
        .css({
          color: '#5C5757',
          opacity: '1',
          cursor: 'pointer'
        });

    }


    /* ==========================================
       LAST SLIDE
    ========================================== */

    else if (
      currentSlide === total - 1
    ) {

      $section.addClass(
        'is-last-slide'
      );


      $prevArrow
        .prop('disabled', false)
        .css({
          color: '#5C5757',
          opacity: '1',
          cursor: 'pointer'
        });


      $nextArrow
        .prop('disabled', true)
        .css({
          color: '#6E6969',
          opacity: '1',
          cursor: 'not-allowed'
        });

    }


    /* ==========================================
       MIDDLE SLIDES
    ========================================== */

    else {

      $section.addClass(
        'is-middle-slide'
      );


      $prevArrow.css(
        'color',
        '#5C5757'
      );


      $nextArrow.css(
        'color',
        '#5C5757'
      );

    }

  }


  /* ================================================
     SLICK INITIALIZATION
  ================================================= */

  $textSlider.slick({

    slidesToShow: 1,

    slidesToScroll: 1,

    infinite: false,

    arrows: true,

    dots: false,

    adaptiveHeight: true,

    speed: 500,

    fade: false,

    prevArrow: $section.find(
      '.testimonial-product-slider__prev'
    ),

    nextArrow: $section.find(
      '.testimonial-product-slider__next'
    )

  });


  /* ================================================
     COUNTER
  ================================================= */

  function updateCounter(currentSlide) {

    const slickInstance =
      $textSlider.slick('getSlick');

    const total =
      slickInstance.slideCount;

    if (!total) {
      return;
    }


    const current =
      (currentSlide % total) + 1;


    $section.find(
      '.testimonial-product-slider__current'
    ).text(current);


    $section.find(
      '.testimonial-product-slider__total'
    ).text(total);

  }


  /* ================================================
     INITIAL STATE
  ================================================= */

  updateCounter(0);

  updateArrowColors(0);


  /* ================================================
     AFTER CHANGE
  ================================================= */

  $textSlider.on(
    'afterChange',
    function (
      event,
      slick,
      currentSlide
    ) {

      updateCounter(currentSlide);

      updateArrowColors(currentSlide);

    }
  );

}

function initAllTestimonialSliders() {
  const sections = document.querySelectorAll('.testimonial-product-slider');
  if (!('IntersectionObserver' in window)) {
    sections.forEach(initTestimonialProductSlider);
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      io.unobserve(entry.target);
      initTestimonialProductSlider(entry.target);
    });
  }, { rootMargin: '600px 0px' });
  sections.forEach((s) => io.observe(s));
}


/* ================================================
   PAGE LOAD
================================================ */

if (
  document.readyState === 'loading'
) {

  document.addEventListener(
    'DOMContentLoaded',
    initAllTestimonialSliders
  );

} else {

  initAllTestimonialSliders();

}


/* ================================================
   SHOPIFY THEME EDITOR
================================================ */

document.addEventListener(
  'shopify:section:load',
  function (event) {

    if (
      event.target &&
      event.target.classList &&
      event.target.classList.contains(
        'testimonial-product-slider'
      )
    ) {

      initTestimonialProductSlider(
        event.target
      );

    } else if (
      event.detail &&
      event.detail.sectionId
    ) {

      const section =
        document.getElementById(
          'shopify-section-' +
          event.detail.sectionId
        );

      if (section) {

        initTestimonialProductSlider(
          section
        );

      }

    }

  }
);